// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__cnWEX","title":"ClientReferral_title__318rA","itemText":"ClientReferral_itemText__3BzVU"};